import React from "react";
import { Link, useHistory } from "react-router-dom";

import { useSelector } from 'react-redux';
import { logout } from '../../flux/actions/auth-actions'
import { store } from '../../flux/redux_setup/store'

import { Grid, Box } from "@material-ui/core";
import Logo from "../../assets/Logo.png";
import UserModel from '../../models/user-model';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import MenuItem from "@material-ui/core/MenuItem";

import Menu from "@material-ui/core/Menu";
import Drawer from "@material-ui/core/Drawer";
import Divider from '@material-ui/core/Divider';
import ImageHeaderComponet from '../ImageHeaderComponet';
import { SearchBarComponent as SearchBar } from '../SearchBar';

import MenuIcon from "@material-ui/icons/Menu";
import PersonIcon from "@material-ui/icons/Person";
import SendIcon from "@material-ui/icons/Send";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import FlagIcon from "@material-ui/icons/Flag";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import HomeIcon from "@material-ui/icons/Home";
import Close from "@material-ui/icons/Close";

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import headerStyles from "../../styles/Home/Header";

import SvgIcon from '@material-ui/core/SvgIcon';
type SvgIconComponent = typeof SvgIcon;

export default function PrimarySearchAppBar() {
  const classes = headerStyles();

  const cartItems = useSelector((state: any) => state.cart.cartItems);

  const user: UserModel = useSelector((state: any) => state.authReducer.user)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);


  const [collapseVale, setCollapseValue] = React.useState<String[]>([]);
  const handleCollapse = (value: string) => () => {
    const currentIndex = collapseVale.indexOf(value);
    const newChecked = [...collapseVale];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setCollapseValue(newChecked);
  };

  const [mobileOpen, setMobileOpen] = React.useState(false);
  let history = useHistory();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const handleLogoutMobile = () => {
    handleDrawerToggle()
    store.dispatch(logout())
  }
  const handleLogout = () => {
    handleMenuClose()
    store.dispatch(logout())
  }

  const navigateToRoute = (handleLink: string) => () => {
    handleDrawerToggle();
    history.push(handleLink);
  }

  const _renderLink = (
    navigateTo: string,
    label: string,
    icon: React.ReactElement<SvgIconComponent> | undefined,
    handleAction: () => void
  ) => {
    return (
      <MenuItem onClick={handleAction} className={classes.menuItem} >
        <Link to={navigateTo} className={classes.menuItemLink} >
          {icon && <IconButton
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            {icon}
          </IconButton>}
          {label}
        </Link>
      </MenuItem>
    )
  }


  const _renderLinkMobile = (
    label: string,
    icon: React.ReactElement<SvgIconComponent> | undefined,
    handleAction: () => void,
    collapse?: boolean
  ) => {
    const open = collapseVale.indexOf(label) !== -1
    return (
      <>
        <ListItem button onClick={handleAction}>
          {icon && <ListItemIcon>
            {icon}
          </ListItemIcon>}
          <ListItemText primary={label} />
          {collapse && (open ? <ExpandLess /> : <ExpandMore />)}
        </ListItem>
        { collapse && <Collapse in={open} timeout="auto" unmountOnExit className={classes.collapseStyle}>
          <List component="div" disablePadding  >
            <ListItem button className={classes.nested} >
              <ListItemText primary={label} />
            </ListItem>
          </List>
        </Collapse>}
      </>
    )
  }

  const _renderLogin = (isMobile: boolean = false) => {
    if (isMobile) {
      return (user && user.id) ?
        _renderLinkMobile("Cerrar sesión", <ExitToAppIcon />, handleLogoutMobile) :
        _renderLinkMobile("Iniciar sesión", <ExitToAppIcon />, navigateToRoute("/login"))
    } else {
      return (user && user.id) ?
        _renderLink("/", "Cerrar sesión", <ExitToAppIcon />, handleLogout) :
        _renderLink("/login", "Iniciar sesión", <ExitToAppIcon />, handleMenuClose)
    }

  }

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      className={classes.menu}
      elevation={1}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {(user && user.id) &&
        <div>
          <ImageHeaderComponet />
          <Divider />
        </div>
      }
      {_renderLink("/", "Home", <HomeIcon />, handleMenuClose)}
      {(user && user.id) && <div>
        {_renderLink("/perfil", "Perfil", <PersonIcon />, handleMenuClose)}
        {_renderLink("/orderslist", "Mis pedidos", <SendIcon />, handleMenuClose)}
        {_renderLink("/", "Direcciones", <FlagIcon />, handleMenuClose)}
      </div>}
      <Divider />
      {_renderLogin()}
    </Menu>
  );

  const renderMobileMenu = (
    <Drawer
      anchor={"left"}
      open={mobileOpen}
      onClose={handleDrawerToggle}
      ModalProps={{
        keepMounted: true // Better open performance on mobile.
      }}
    >
      <ListItem className={classes.drawerHeader}>
        <Box pl={1}>
          <img
            src={Logo}
            alt="Cava Don Carlos"
            className={classes.logoHeader}
            onClick={() => window.location.href = "/"}
          />
        </Box>
        <IconButton onClick={handleDrawerToggle} style={{ color: "#fff" }}>
          <Close />
        </IconButton>
      </ListItem>
      {(user && user.id) &&
        <div>
          <ImageHeaderComponet />
          <Divider />
        </div>
      }
      {_renderLinkMobile("Home", undefined, navigateToRoute("/"))}
      {_renderLinkMobile("Nuestra Tienda", undefined, navigateToRoute("/tienda"))}
      {/*  
      {_renderLinkMobile("Vinos", undefined, handleCollapse("Vinos"), true)}
      {_renderLinkMobile("Destilados", undefined, handleCollapse("Destilados"), true)}
      {_renderLinkMobile("Marcas", undefined, handleCollapse("Marcas"), true)}
      {_renderLinkMobile("Ofertas", undefined, navigateToRoute("/"))}
      */}
      <Divider />
      {(user && user.id) && <>
        {_renderLinkMobile("Perfil", <PersonIcon />, navigateToRoute("/perfil"))}
        {_renderLinkMobile("Mis pedidos", <SendIcon />, navigateToRoute("/orderslist"))}
        {_renderLinkMobile("Direcciones", <FlagIcon />, navigateToRoute("/"))}
      </>}
      {_renderLogin(true)}
    </Drawer>
  );

  return (
    <AppBar position="sticky" className={classes.backgroundColor}>
      <Toolbar>
        <Grid container alignItems="center">
          <Grid item xs={4} md={4} style={{ display: "flex" }}>
            <IconButton
              edge="start"
              className={classes.menuButton}
              onClick={handleDrawerToggle}
              color="inherit"
              aria-label="open drawer"
            >
              <MenuIcon />
            </IconButton>
            <img
              src={Logo}
              alt="Cava Don Carlos"
              className={classes.logoHeader}
              onClick={() => window.location.href = "/"}
            />
          </Grid>
          <Grid item xs={7} md={4} className={classes.headerMenu}>
            <Link to="/tienda" className="text-normalize">
              <span>Nuestra Tienda</span>
            </Link>
          </Grid>
          <Grid item xs={8} md={4}>
            <div className={classes.sectionDesktop}>
              <SearchBar placeholder="Buscar en nuestra tienda"/>
              <Link className="text-normalize" to="/checkoutprocess/">
                <IconButton aria-label="show 1 new product" color="inherit">
                  <Badge badgeContent={cartItems ? cartItems.length : 0} color="secondary">
                      <ShoppingCartIcon />
                  </Badge>
                </IconButton>
              </Link>
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <MoreVertIcon />
              </IconButton>
            </div>
            <div className={classes.sectionMobile}>
              <IconButton aria-label="Search" color="inherit">
                <SearchBar placeholder="Buscar en nuestra tienda"/>
              </IconButton>
              <IconButton aria-label="show 1 new product" color="inherit" className={classes.shoppingCartIconContainer}>
                <Badge badgeContent={cartItems ? cartItems.length : 0} color="secondary">
                  <Link className="text-normalize" to="/checkoutprocess/">
                    <ShoppingCartIcon />
                  </Link>
                </Badge>
              </IconButton>
            </div>
          </Grid>
        </Grid>
      </Toolbar>
      {renderMobileMenu}
      {renderMenu}
    </AppBar>
  );
}
